export default ['$q', 'JsonRPCService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', function ($q, JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var xCenterRoute = xCenterRouteConfig;
    var endpoint = endpointConfig.emailEndpoint;

    return {
        emailQuote: function emailQuote(quoteEmailDTO) {
            var deferred = $q.defer();
            JsonRPCService.send(xCenterRoute, endpoint, 'emailQuote', [quoteEmailDTO]).then(function () {
                return deferred.resolve();
            }, function (error, status, headers) {
                return deferred.reject([error, status, headers]);
            });
            return deferred.promise;
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/services/EmailService.js
// module id = 857
// module chunks = 0